import * as React from 'react';
import styled, { withTheme } from 'styled-components';
import { rem } from 'polished';
import { FlexRowCenter } from '../../Defaults/Flexbox/Flexbox';
import { __ } from 'react-i18n';
import { TextP } from '../../Defaults/Text';
import { IconImg } from '../../Defaults/Icon/IconImg';

function FreeDelivery({}) {
  return (
    <Wrapper>
      <Text>{__('Doprava zadarmo')}</Text>
      <IconImg src={'/assets/zemplin/delivery.svg'} alt="delivery-icon" />
    </Wrapper>
  );
}

const Wrapper = styled(FlexRowCenter)`
  margin-left: ${rem(8)};
`;

const Text = styled(TextP)`
  font-family: ${({ theme }) => theme.font.tertiary};
  font-weight: 600;
  font-size: ${rem(12)};
  color: #2dcc8d;
  line-height: ${rem(12)};
  margin-right: ${rem(9)};
  text-transform: uppercase;
  text-align: right;
`;

export { FreeDelivery };
